export class QuickBooksAddRefreshTokenModel{

    public code:string;
    public internalCompanyId:Number;
    public realmId:string;
    public state:string;
}